// material ui
import { alpha, Chip } from '@mui/material';

const getTrendColor = (percentage) => {
  if (percentage > 0) {
    return 'success'; // Green for positive savings
  } else if (percentage < 0) {
    return 'error'; // Red for negative savings
  } else {
    return 'warning'; // Grey for no change
  }
};

const PercentageTrendChip = ({ value }) => {
  return (
    <Chip
      variant="filled"
      sx={{
        marginLeft: 1,
        borderRadius: 2,
        backgroundColor: (theme) =>
          alpha(theme.palette[getTrendColor(value)].main, 0.1),
        color: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette[getTrendColor(value)].dark
            : theme.palette[getTrendColor(value)].light,
      }}
      label={value ? `${value.toFixed(1)}%` : '0%'}
      size="small"
    />
  );
};

export default PercentageTrendChip;
